/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Person,
    PersonFromJSON,
    PersonFromJSONTyped,
    PersonToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetPersonResponse
 */
export interface GetPersonResponse {
    /**
     * 
     * @type {Person}
     * @memberof GetPersonResponse
     */
    person?: Person;
}

export function GetPersonResponseFromJSON(json: any): GetPersonResponse {
    return GetPersonResponseFromJSONTyped(json, false);
}

export function GetPersonResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPersonResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'person': !exists(json, 'person') ? undefined : PersonFromJSON(json['person']),
    };
}

export function GetPersonResponseToJSON(value?: GetPersonResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'person': PersonToJSON(value.person),
    };
}


